// Core
import { Link } from "react-router-dom";
import { clearAuthCookies, getAuthToken } from "../../../../Utils/Helpers/Auth/authCookie";
import { useState } from "react";

// UI
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import MenuMaterial from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Settings from "@mui/icons-material/Settings";
import Divider from "@mui/material/Divider";
import Logout from "@mui/icons-material/Logout";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { ThemeProvider } from "@mui/material/styles";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";

// Tools
import logo from "../../../../Img/logo.png";
import { themeMenu } from "../../../../Themes/themes.jsx";

const theme = themeMenu;

export function Menu(props) {
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAuthToken()
            },
            // Нужен, чтобы браузер применил серверный Set-Cookie, которым
            // AuthController::logout теперь чистит общую cookie 'token'
            // (AuthController::withoutAuthCookie).
            credentials: 'include',
        };

        fetch(`${process.env.REACT_APP_REST_API}/auth/logout`, requestOptions)
            .catch((error) => {
                // Локальный выход не должен зависеть от ответа сервера — иначе
                // при 401/429/сетевой ошибке пользователь остаётся залогинен
                // здесь, пока web уже вышел (рассинхронизация auth-состояния).
                console.log(error);
            })
            .finally(() => {
                clearAuthCookies();
                window.location = window.location.protocol === 'https:' ? process.env.REACT_APP_BASIC : process.env.REACT_APP_LOCAL_BASIC;
            })
    }

    return (
        <nav id="navPanel">
            <ThemeProvider theme={theme}>
                <Box sx={{ flexGrow: 1 }}>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                <Button color="inherit" onClick={() => {
                                    const basicUrl = window.location.protocol === 'https:' 
                                        ? process.env.REACT_APP_BASIC
                                        : process.env.REACT_APP_LOCAL_BASIC;
                                    window.location.href = basicUrl;
                                }}>
                                    <img style={{ height: '22px' }} src={logo} alt='Логотип' />
                                </Button>
                            </Typography>
                            <div>
                                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                                    <Tooltip title="Account settings">
                                        <IconButton
                                            onClick={handleClick}
                                            size="small"
                                            sx={{ ml: 2 }}
                                            aria-controls={open ? 'Account-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                        >
                                            <Avatar sx={{ width: 32, height: 32 }} src={props.user?.user_profile?.photo?.url}>{props.user?.user_profile?.first_name?.at(0)}</Avatar>
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <MenuMaterial
                                    anchorEl={anchorEl}
                                    id="account-menu"
                                    open={open}
                                    onClose={handleClose}
                                    onClick={handleClose}
                                    PaperProps={{
                                        elevation: 0,
                                        sx: {
                                            overflow: 'visible',
                                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                            mt: 1.5,
                                            '& .MuiAvatar-root': {
                                                width: 32,
                                                height: 32,
                                                ml: -0.5,
                                                mr: 1,
                                            },
                                            '&:before': {
                                                content: '""',
                                                display: 'block',
                                                position: 'absolute',
                                                top: 0,
                                                right: 14,
                                                width: 10,
                                                height: 10,
                                                bgcolor: 'background.paper',
                                                transform: 'translateY(-50%) rotate(45deg)',
                                                zIndex: 0,
                                            },
                                        },
                                    }}
                                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                >
                                    <MenuItem>
                                        <ListItemIcon>
                                            <ArrowCircleUpIcon fontSize="small" />
                                        </ListItemIcon>
                                        <Link style={{ color: "black" }} to="booking-request/all">Запросы</Link>
                                    </MenuItem>
                                    <MenuItem>
                                        <ListItemIcon>
                                            <RateReviewOutlinedIcon />
                                        </ListItemIcon>
                                        <Link style={{ color: "black" }} to="progress/reviews">Отзывы</Link>
                                    </MenuItem>
                                    <MenuItem>
                                        <ListItemIcon>
                                            <Settings fontSize="small" />
                                        </ListItemIcon>
                                        <Link style={{ color: "black" }} to="account-settings">Аккаунт</Link>
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={handleLogout}>
                                        <ListItemIcon>
                                            <Logout fontSize="small" />
                                        </ListItemIcon>
                                        Выйти
                                    </MenuItem>
                                </MenuMaterial>
                            </div>
                        </Toolbar>
                    </AppBar>
                </Box>
            </ThemeProvider>
        </nav>
    )
}
